<h2 mat-dialog-title>Add Proficiency Test</h2>

<form [formGroup]="newProficiency">
  <mat-dialog-content [formGroup]="newProficiency">
    <div class="flex flex-col">
      <mat-form-field>
        <mat-label>Analyte</mat-label>
        <mat-select formControlName="Analyte" (selectionChange)="updateFields($event.value)">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let prof of proficiencies" [value]="prof.ptTest">{{prof.ptTest}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="newProficiency.get('Analyte').invalid">
          Required field.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Specialty</mat-label>
        <input matInput formControlName="Specialty">
        <mat-error *ngIf="newProficiency.get('Specialty').invalid">
          Required field.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Sub-Specialty</mat-label>
        <input matInput formControlName="SubSpecialty">
        <mat-error *ngIf="newProficiency.get('SubSpecialty').invalid">
          Required field.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Test Code</mat-label>
        <input matInput formControlName="TestCode">
        <mat-error *ngIf="newProficiency.get('TestCode').invalid">
          Required field.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Evaluator</mat-label>
        <mat-select formControlName="Evaluator">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let evaluator of eval" [value]="evaluator.code">{{evaluator.code}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="newProficiency.get('Evaluator').invalid">
          Required field.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Test Id</mat-label>
        <input matInput formControlName="TestId">
        <mat-error *ngIf="newProficiency.get('TestId').invalid">
          Required field.
        </mat-error>
      </mat-form-field>
      <div class="flex flex-row padding10">
        <button mat-raised-button style="margin-right: 20px;" (click)="close()">Cancel</button>
        <button mat-raised-button class="mat-raised-button mat-primary" (click)="save()">Save</button>
      </div>
    </div>

  </mat-dialog-content>
</form>